export enum PaymentTypeEnum {
  NONE = "None",
  MOBILE_PAY = "MobilePayPaymentService",
  BSPAYMENT = "PaymentService",
}
